import { createContext, Dispatch, SetStateAction, useContext, Context } from 'react';
import { VehicleAddonItem } from '../services/VehicleAddonsService';

export type SelectedOptionType = {
    name: string,
    value: string
}

export type VariantEdgeType = {
    "node": {
        availableForSale: boolean,
        compareAtPrice: {
            amount: string,
            currencyCode: string,
        },
        currentlyNotInStock: boolean,
        id: string,
        image: {
            id: string,
            url: string
        },
        priceV2: {
            amount: string,
            currencyCode: string,
        },
        selectedOptions: SelectedOptionType[]
        sku: string,
        title: string,
        preorder_enabled?: {
            value: string
        },
        preorder_ship_date?: {
            value: string
        }
    }
}

export type VariantType = {
    edges: VariantEdgeType[]
}

export type ProductType = {
    options?: any;
    images: string[],
    title: string,
    variants: VariantType,
}
export type AppDataType = {
    step?: number | undefined,
    seat?: string | undefined,
    color?: string | undefined,
    selectedId?: string | undefined,
    year?: number | string | undefined,
    make?: string | undefined,
    model?: string | undefined,
    check?: { compatibility: string, compatibility_custom: string, compatibility_custom_raw?: string, availability: object, has_rm?: boolean, vehicle_type?: string } | undefined,
    product?: ProductType | undefined,
    originalProduct?: ProductType | undefined
    addons?: string | undefined
    trim?: string | undefined
    cab?: string | undefined
    has_trims?: boolean | undefined
    has_cabs?: boolean | undefined
    with_bonus?: boolean | undefined
    trims?: object | undefined | null,
    isFetchingCheck?: boolean | undefined,
    configurator_complete?: boolean | undefined,
    configurator_has_questions?: boolean | undefined,
    biz2_availability_loading?: boolean | undefined,
    biz2_coverages?: Record<string, Record<string, { variant_id: number | null; available: boolean; [key: string]: any }>> | null,
    sku_mapping_availability?: Record<string, any> | null,
    show_upsell?: boolean | undefined,
    show_offer?: boolean | undefined,
    modelTemp?: string | undefined,
    captions?: any | undefined,
    ultimate_upgrade?: boolean | undefined,
    selectedVehicleAddons?: VehicleAddonItem[] | undefined,
    customRearProduct?: ProductType | undefined,
    customRearAddons?: string[] | undefined,
    configurator_display_mode?: 'icon_path' | 'trim_cab_only' | 'both' | undefined,
} | null

type AppDataContextType = {
    currentAppData: AppDataType | null
    setCurrentAppData: Dispatch<SetStateAction<AppDataType | null>>
}

export const AppDataContext = createContext<AppDataContextType | undefined>(undefined)

// ...

export function useContextThrowUndefined<T>(
    context: Context<T | undefined>
): T {
    const value = useContext(context);
    if (value === undefined) {
        const name = context.displayName ?? "Unnamed";
        throw new Error(
            `${name} context consumer was used outside of a context provider.
To fix this, make sure the provider is always higher up the component tree than the consumer.`
        );
    }
    return value;
}

export const useAppData = () => useContextThrowUndefined(AppDataContext);
